export const uploadsLanding = [
  { label: 'Home', url: '/' },
  { label: 'Uploads', url: '/uploads' },
];

export const IMAGE_UPLOAD_ROUTE = '/uploads/uploadimages';

export const viewUploadImages = [
  ...uploadsLanding,
  { label: 'Upload Images', url: IMAGE_UPLOAD_ROUTE },
];
